/* eslint-disable semi,semi-style */
import React, { FunctionComponent } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import Header, { UserInfo, UserInfoContext } from './components/header/index';
import Loader from './components/Loader';
import Index from './components/Index';
import Tools from './components/tools';
import { DirectApply } from './page/direct-apply';
import { Account } from './page/account';
import platforms from './config';
import { login, logout } from '../../util/login';
import { getUserInfoInDirect } from '../index/service';
import './index.scss';
import './antd.less';

interface AppProps {}

const App: FunctionComponent<AppProps> = () => {
  const { data, loading, error } = useRequest(getUserInfoInDirect);
  console.log('In direct', { data, loading, error });
  let userInfo = undefined;
  if (data) {
    // 需求：当刷新页面时，这个账号在当期桩企（local 中的 id）下没有权限了（即 data.companyIds.includes），则退出登录
    const localId = localStorage.getItem('open-epower-direct-company-id')
    const localIdParsed = localId ? JSON.parse(localId) : null;
    if (localIdParsed && data.companyIds?.length) {
      const isAll = data.companyIds.includes('-1');
      console.log("🚀 ~ App ~ isAll:", isAll, data.companyIds, localIdParsed);
      if (!isAll) {
        if (!data.companyIds.includes(localIdParsed)) {
          console.log("🚀 ~ App ~ 命中登出:", localIdParsed);
          localStorage.clear();
          location.href = logout();
          return null;
        }
      }
    } else if (localIdParsed && data.companyIds?.length == 0){
      // 说明被删光了
      console.log("🚀 ~ App ~ 桩企权限被删光了:", localIdParsed);
      localStorage.clear();
      location.href = logout();
      return null;
    }
    userInfo = Object.assign(
      {
        loginError: false,
      },
      data,
    );
  } else if (error) {
    userInfo = Object.assign(
      {},
      {
        loginError: true,
      },
    );
  }
  window.Login = login;
  window.loginInfo = userInfo;
  window.loginPending = loading;

  return (
    <Spin spinning={loading}>
      <UserInfoContext.Provider value={userInfo}>
        <Router>
          <Header user={data} />
          <Switch>
            <Route path="/" exact component={Index} />
            <Route path="/comming" exact render={() => <Tools type="comming" />} />
            <Route path="/needauth" exact render={() => <Tools type="needauth" />} />
            {/* <Route path="/devops" exact render={() => <Tools type="comming" />} /> */}
            {platforms.map((item, key) => (
              <Route key={key} path={item.path} exact={!!item.exact} render={() => <Loader source={item} />} />
            ))}
            <Route path="/directApply" exact component={DirectApply} />
            <Route path="/account/profile" component={Account} />
          </Switch>
        </Router>
      </UserInfoContext.Provider>
    </Spin>
  );
};

export default App
